import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import Loader from "../ui/Loader";
import useTableStyles from "../../styles/useTableStyles";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { useParams } from "react-router";
import formatDates from "../../util/dateFormat";
import { useAppSelector } from "../../redux/hooks";

const MerchantActivityLog = () => {
  const tableStyle = useTableStyles();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [activityLogData, setActivityLogData] = useState([]);

  const params = useParams();
  const { merchantId } = params;

  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const external_idForLogs = entireList.find(
    (item: any) => item.id === merchantId
  ).external_id;

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL +
          APIConstants.getMemberLogs +
          "?email=" +
          external_idForLogs
        }`
      );
      const mapedData = response.data.result.map((item: any, index: any) => ({
        createdAt: formatDates(item.createdAt),
        activityTitle: item.activity,
        createdBy: item.createdBy ? item.createdBy : "-",
      }));

      mapedData.sort(
        (
          a: { createdAt: string | number | Date },
          b: { createdAt: string | number | Date }
        ) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      setActivityLogData(mapedData);
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Grid>
      <Box
        display={"flex"}
        flexDirection={"column"}
        width="100%"
        sx={{
          overflow: "auto",
          borderRadius: "8px",
          ...tableStyle.scrollbar,
        }}
        // border={theme.border?.newGreyBorder}
      >
        <Table sx={{ width: "100%" }}>
          <TableHead sx={{ backgroundColor: theme.color?.tableHeader }}>
            <TableRow>
              <TableCell
                align="center"
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableHeader,
                  color: theme.color?.tableGrey,
                }}
              >
                Activity Title
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableHeader,
                  color: theme.color?.tableGrey,
                }}
              >
                Created By
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.tableHeader,
                  color: theme.color?.tableGrey,
                }}
              >
                Created Date
              </TableCell>
            </TableRow>
          </TableHead>
          {!loading ? (
            <TableBody
              sx={{
                backgroundColor: theme?.color?.background,
                width: "100%",
                color: theme.color?.tableGrey,
              }}
            >
              {activityLogData.map((activity: any) => (
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableHeader,
                      wordWrap: "break-word",
                    }}
                  >
                    {activity ? activity.activityTitle : "-"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableHeader,
                    }}
                  >
                    {activity ? activity.createdBy : "-"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.tableHeader,
                    }}
                  >
                    {activity ? activity.createdAt : "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableCell colSpan={6}>
                <Grid
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Loader />
                </Grid>
              </TableCell>
            </TableBody>
          )}
        </Table>
        {error && (
          <Grid
            py={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
          >
            <Typography
              fontFamily={theme?.font?.fontFamily.primary}
              sx={{ color: theme.color?.tableGrey }}
            >
              Something went wrong, please try again later.
            </Typography>
          </Grid>
        )}
        {activityLogData.length === 0 && !loading && (
          <Grid
            py={2}
            width={"100%"}
            display={"flex"}
            justifyContent={"center"}
          >
            <Typography
              fontFamily={theme?.font?.fontFamily.primary}
              sx={{ color: theme.color?.tableGrey }}
            >
              No data to display
            </Typography>
          </Grid>
        )}
      </Box>
    </Grid>
  );
};

export default MerchantActivityLog;
